import { Injectable, signal} from '@angular/core';
import moment from 'moment';
import { DATE_SELECTOR_OPTIONS, ArriveAtOption, leaveAtOption } from '../constants/date-selector-options.constant';
import { DateRequestOptions } from '../models/date-request-options.model';

@Injectable({
  providedIn: 'root'
})

export class RouteFormDateSelectorService {


  public leaveNowDate =  signal(new Date());
  public leaveNowHour =  signal(this.getCurrentHour());

  public leaveAtDate =  signal(new Date());
  public leaveAtHour =  signal(this.getCurrentHour());

  public arriveAtDate =  signal(new Date());
  public arriveAtHour =  signal(this.getCurrentHour());

  public dateOptionSelected = signal(DATE_SELECTOR_OPTIONS[0]);

  public minHour = this.calculateMinHour();

  public resetDates() {
    const currentHour = this.getCurrentHour();
    this.leaveNowDate.set(new Date());
    this.leaveNowHour.set(currentHour);

    this.leaveAtDate.set(new Date());
    this.leaveAtHour.set(currentHour);

    this.arriveAtDate.set(new Date());
    this.arriveAtHour.set(currentHour);

    this.dateOptionSelected.set(DATE_SELECTOR_OPTIONS[0]);
  }

  public getDateOptionSelected() {
    return this.dateOptionSelected.asReadonly();
  }

  public checkDateValidity(date: Date) {
    const currentDate = moment(new Date(), "DD/MM/YYYY");
    const dateToCheck = moment(date, "DD/MM/YYYY");

    if(dateToCheck.isBefore(currentDate)) {
      return false;
    }

    return true;
  }

  public checkHourValidity(date: Date, hour: string) {
    const currentDate = moment(new Date(), "DD/MM/YYYY HH:mm");
    const dateToCheck = moment(`${moment(date).format('DD/MM/YYYY')} ${hour}`, "DD/MM/YYYY HH:mm");

    if(dateToCheck.isBefore(currentDate)) {
      return false;
    }

    return true;
  }

  public checkTwoDatesEqual(date1:Date, date2:Date) {
    const date1Formatted = moment(date1).format('DD/MM/YYYY');
    const date2Formatted = moment(date2).format('DD/MM/YYYY');

    if(date1Formatted === date2Formatted) {
      return true;
    }

    return false;
  }

  public getCurrentHour() {
    return moment(new Date()).format('HH:mm');
  }

  public getMinHour() {
    return this.minHour
  }

  public calculateMinHour() {
    const currentHour = this.getCurrentHour();
    if (currentHour === '00:00') {
      return currentHour;
    }
    return moment(currentHour, 'HH:mm').subtract(1, 'minutes').format('HH:mm');
  }

  public momentToLocale(date: Date) {
    return moment(date).format('DD/MM/YYYY');
  }

  public getDataForRequest(): DateRequestOptions {
    const arriveBy = this.dateOptionSelected().id === ArriveAtOption.id;
    return {
      arriveBy,
      ...this.getDateAndHourForRequest(arriveBy)
    }
  }

  public setDateFromUrlParams(params: DateRequestOptions) {
    const hour = moment(params.time, 'h:mm A').format('HH:mm');
    const date = new Date(params.date);
    if (!this.checkHourValidity(date, hour)) {
      return;
    }
    if(params.arriveBy) {
      this.dateOptionSelected.set(ArriveAtOption);
      this.arriveAtDate.set(date);
      this.arriveAtHour.set(hour);
    } else {
      this.dateOptionSelected.set(leaveAtOption);
      this.leaveAtDate.set(date);
      this.leaveAtHour.set(hour);
    }
  }

  private getDateAndHourForRequest(arriveBy: boolean) {
    let date;
    let time;
    const currentMoment = moment(new Date());
    if(arriveBy) {
      const arriveByDateIsLaterThanNow = this.checkHourValidity(this.arriveAtDate(), this.arriveAtHour());
      date = arriveByDateIsLaterThanNow ? moment(this.arriveAtDate()).format('MM/DD/YYYY'): moment(currentMoment).format('MM/DD/YYYY');
      time  = arriveByDateIsLaterThanNow ? moment(this.arriveAtHour(), 'HH:mm').format('h:mm A') : moment(currentMoment).format('h:mm A');
    } else {
      if(this.dateOptionSelected().id === leaveAtOption.id) {
        const leaveAtDateIsLaterThanNow = this.checkHourValidity(this.leaveAtDate(), this.leaveAtHour());
        date = leaveAtDateIsLaterThanNow ? moment(this.leaveAtDate()).format('MM/DD/YYYY') : moment(currentMoment).format('MM/DD/YYYY');
        time  = leaveAtDateIsLaterThanNow ? moment(this.leaveAtHour(), 'HH:mm').format('h:mm A') : moment(currentMoment).format('h:mm A');
      } else {
        date = moment(currentMoment).format('MM/DD/YYYY');
        time = moment(currentMoment).format('h:mm A');
      }
    }
    return { date, time };
  }

}
